/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * modules.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import module.
 */
import { smoothScrollTo } from "./smoothScrollTo";
import { setDrawerButton } from "./setDrawerButton";
import { mouseStalker } from "./setMouseStalker";
import { scrollBar } from "./setScrollBar";
import { setSplash } from "./setSplash";
import { setScrollTrigger } from "./setScrollTrigger";
import "./setInstagramSlider";
let mediaQuery = window.matchMedia("(min-width: 1025px)").matches;

/**
 * 追加モジュール
 */
const add__modules = () => {

  //砂嵐
  const sandstorm = () => {
    main();

    function main() {
      let resizeWindowWidth = window.innerWidth;
      let resizeWindowHeight = window.innerHeight;

      const canvas = document.getElementById("canvas")
      canvas.width = resizeWindowWidth;
      canvas.height = resizeWindowHeight;

      //リサイズイベント
      let timer = false;
      function resizeEvent() {
        let resize_width = window.innerWidth;
        if (resizeWindowWidth != resize_width) {
          timer !== false && clearTimeout(timer);
          timer = setTimeout(function () {
            resizeWindowWidth = window.innerWidth;
            resizeWindowHeight = window.innerHeight;
            canvas.width = resizeWindowWidth;
            canvas.height = resizeWindowHeight;
          }, 100);
        }
      }

      window.addEventListener("orientationchange", resizeEvent);
      window.addEventListener("resize", resizeEvent);

      setInterval((function () {
        sandstorm(canvas)
      }), 100);
    }

    function sandstorm(canvas) {
      let context = canvas.getContext("2d", { willReadFrequently: true })
      let src = context.getImageData(0, 0, canvas.clientWidth, canvas.clientHeight);
      let dst = context.createImageData(canvas.clientWidth, canvas.clientHeight);
      for (let i = 0; i < src.data.length; i += 4) {
        dst.data[i] = dst.data[i + 1] = dst.data[i + 2] = Math.ceil(Math.random() * 255)
        dst.data[i + 3] = 255;
      }
      context.putImageData(dst, 0, 0);
    }
  }

  sandstorm();
}

/**
 * Do modules.
 */
function modules() {
  smoothScrollTo();
  setDrawerButton();
  mediaQuery && mouseStalker();
  scrollBar();
  setSplash();
  setScrollTrigger();
  add__modules();
}

export { modules };
